import React, { useState, useEffect } from 'react';
import { icons } from '../../helpers/constants';
import { useTranslation } from 'react-i18next';

const InfoPill = ({ type }) => {
    const { t } = useTranslation();


    const infoPillConfig = {
        engineblock_on: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-red-alt me-2",
            text: t("devices.engineblock_on"),
            textClass: "text-white",
        },
        override_on: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-primary-gradient me-2",
            text: t("devices.override_on"),
            textClass: "text-white",    
        },
        engineblockpending_on: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.engineblockpending_on"),
            textClass: "dark_grey",
        },
        override_pending: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.override_pending"),
            textClass: "dark_grey",
        },
        online: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-primary-gradient me-2",
            text: t("devices.online"),
            textClass: "text-white",    
        },
        vehicle_on:{
            className: "d-flex align-items-center infopill px-2 py-1 bg-primary-gradient me-2",
            text: t("devices.vehicle_on"),
            textClass: "text-white",    
        },
        vehicle_off:{
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.vehicle_off"),
            textClass: "dark_grey",
        },
        sleeping: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.sleeping"),
            textClass: "dark_grey",
        },
        offline: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.offline"),
            textClass: "dark_grey",        
        },
        no_dataplan: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-red-alt me-2",
            icon: icons.sidebar.card_active,
            iconClass: "size16 white-white-icon me-1",
            text: t("devices.no_dataplan"),
            textClass: "text-white",
        },
        awaiting_connection: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            text: t("devices.awaiting_connection"),
            textClass: "dark_grey",
        },
        stolenmode: {
            className: "d-flex justify-center align-items-center infopill px-2 py-1 bg-primary me-2",
            icon: icons.stolenmode,
            iconClass: "size16 white-white-icon me-1",
            text: t("devices.stolen_mode_on"),
            textClass: "text-white",
        },
        alarmcenter_armed: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-primary me-2",
            icon: icons.central,
            iconClass: "size16 white-white-icon me-1",
            text: t("devices.alarmcenter_armed"),
            textClass: "text-white",
        },
        alarmcenter_unarmed: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-grey me-2",
            icon: icons.central,
            iconClass: "size16 dark-grey-icon me-1",
            text: t("devices.alarmcenter_unarmed"),
            textClass: "dark_grey",
        },
        alarmcenter_triggered: {
            className: "d-flex align-items-center infopill px-2 py-1 bg-red-alt me-2",
            icon: icons.central,
            iconClass: "size16 white-icon me-1",
            text: t("devices.alarmcenter_triggered"),
            textClass: "text-white",
        },

    };

    const config = infoPillConfig[type];
	if (!config) return null;
    return(
        <>
        <div className={config.className}>
			{config.icon && <img className={config.iconClass} src={config.icon} alt="" />}
			<p className={config.textClass}>{config.text}</p>
		</div>
        </>
    )
}

export default InfoPill;